<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col xs="12">
          <div class="card p-3 m-lg-3 mb-2">
            <div class="header-card d-flex justify-between">
                <div>
                    <p class="card-title">Your Metrics</p>
                    <p>
                        The data don't Lie! Push harder to get better consistent
                        metrics. You can do better!
                    </p>
                </div>
                
                <div>
                    <p>Select Count of Past tests</p>
                    <b-form-group class="label" label-for="target">
                        <b-form-select
                          id="target"
                          v-model="limit"
                          @change="changeLimit"
                          :options="levels"
                          required
                        >
                          <b-form-select-option value="null"
                            >-- Select --</b-form-select-option
                          >
                        </b-form-select>
                      </b-form-group>
                </div>

              
            </div>
            <div v-if="loading && !usermetrics.status" class="mb-5">
              You have not taken any test yet. <br /><b-button
                class="v-button p-lg-2"
                :to="{ name: 'select' }"
                variant="success"
                >Take a Test</b-button
              >
            </div>
            <b-skeleton-wrapper
              class="text-center"
              :loading="loading && !usermetrics.status"
            >
              <template #loading>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="90%"></b-skeleton>
                <b-skeleton width="100%" class="mt-3"></b-skeleton>
                <b-skeleton width="80%"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </template>
              <div class="body-card">
                <div class="field-division" v-if="usermetrics.status">
                  <div class="catbutton">
                    <button
                      v-for="(category, index) in usermetrics.data.categories"
                      :key="index"
                      @click="currentcategory = category"
                      class="up-btn m-1"
                      :class="
                        currentcategory == category ? 'active' : 'inactive'
                      "
                      variant="primary"
                    >
                      {{ category }}
                    </button>
                  </div>

                  <div class="metric-item-wrapper">
                    <p class="metric-item-header">
                      Overall Perfomance curve (Most recent Tests)
                    </p>
                    <mini-line
                      :chartdata="currentmetrics.data.overallperf"
                    ></mini-line>
                  </div>
                  <div class="metric-item-wrapper">
                    <p class="metric-item-header">
                      Overall Average Perfomance Per Subject (Most recent Tests)
                    </p>
                    <mini-column
                      :chartdata="currentmetrics.data.subjectperf"
                    ></mini-column>
                  </div>
                  <div class="metric-item-wrapper">
                    <p class="metric-item-header">
                      Total time spent Practising (Alltime)
                    </p>
                    <pie-text
                      :chartdata="currentmetrics.data.totaltimespentp"
                      suffix=""
                    ></pie-text>
                    <p class="metric-item-text">
                      Spend Some time to practice after each Study. This will
                      build your confidence, test your ability, challenge your
                      weakness and also boost your preparation.
                    </p>
                  </div>
                  <div class="metric-item-wrapper">
                    <p class="metric-item-header">
                      Readiness Level for Optimum performance (For this Exam)
                    </p>
                    <pie-text
                      :chartdata="currentmetrics.data.readinesslevel"
                      suffix="% ready!"
                    ></pie-text>
                    <p class="metric-item-text">
                      The battle is not won on the battle day, but days before
                      in the barracks. If you will do interestingly well in this
                      exam,
                      <b>Your readiness level for optimum performance</b> must
                      be high also because this is the barracks where you are
                      tested for the battle.
                    </p>
                  </div>
                </div>
              </div>
            </b-skeleton-wrapper>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import miniPie from "@/components/miniPie"
import miniColumn from "@/components/miniColumn";
import miniLine from "@/components/miniLine";
import pieText from "@/components/pieText";

export default {
  components: {
    // miniPie
    miniColumn,
    miniLine,
    pieText
  },
  data() {
    return {
      currentcategory: "",
      currentmetrics: [],
      limit: 20,
      usermetrics: [],
      loading: false,
      levels: [10, 25, 50, 100, 250, 500],
    };
  },

  mounted() {
    this.fetchMetrics();
  },
  watch: {
    usermetrics() {
      if (this.usermetrics.length > 0) {
        this.currentcategory = this.usermetrics.data.categories[0];
        // console.log(this.currentcategory)
      }
    },
    currentcategory() {
      this.currentmetrics = this.usermetrics.data.data[this.currentcategory];
      // console.log(this.currentmetrics)
    }
  },
  methods: {
    ...mapActions("dashboard", ["fetchUsermetrics"]),
    async fetchMetrics() {

        this.loading = true;

        try {
            const response = await this.fetchUsermetrics(this.limit);
            
            this.usermetrics = response.data;
            this.currentcategory = this.usermetrics.data.categories[0];
            this.currentmetrics = this.usermetrics.data.data[this.currentcategory];
            
            // this.leaderboardTable = response?.data?.data.current_board
            // this.meta = response.data.meta

            console.log(response)

            this.loading = false;
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false
        }
    },
    changeLimit(){
        this.fetchMetrics();
    },
    dateFormatter(rawdate) {
      let monthArray = [
        "Jan",
        "Feb",
        "Mar",
        "April",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ];
      let daysArray = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      let sdate = new Date(rawdate);
      let sdatestring =
        daysArray[sdate.getUTCDay()] +
        ", " +
        monthArray[sdate.getMonth()] +
        " " +
        sdate.getDate() +
        ", " +
        sdate.getFullYear();

      return sdatestring;
    },
    timeformatter(rawdatetime) {
      // let monthArray = ["Jan", "Feb", "Mar", "April", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
      let sdate = new Date(rawdatetime);
      // let sdatestring =  monthArray[sdate.getMonth()] + ' ' + sdate.getDate() + ', ' + sdate.getFullYear();
      // this.scheduledate = sdatestring
      let stimestring =
        (sdate.getHours() < 12 ? sdate.getHours() : sdate.getHours() - 12) +
        ":" +
        (sdate.getMinutes() < 10
          ? `0${sdate.getMinutes()}`
          : sdate.getMinutes()) +
        (sdate.getHours() < 12 ? "am" : "pm");
      // this.scheduletime = stimestring;

      return stimestring;
    },
    makeString(rawarray) {
      let arraystring = rawarray.toString();

      return arraystring;
    }
  },

  computed: {
    ...mapState({
      testspacearray: state => state.admin.listtestspaces,
      testspacestats: state => state.admin.testspacestats,
    })

    // usetestspacearray() {
    //   return this.testspacearray.slice(this.startnum, this.endnum);
    // },
    // endss() {
    //   let end = this.testspacearray.length;
    //   return end;
    // },
    // ranger() {
    //   let ranger = Math.ceil(this.testspacearray.length / this.intervalnum);
    //   return ranger;
    // },
    // retrieving() {
    //   //let trid = this.$route.params.trackid;

    //   let curres = this.testspacearray.length;
    //   //this.result = curres;

    //   if (curres <= 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
  }
};
</script>

<style scoped>
.card {
  /* min-height: 70vh; */
  background-color: rgb(242, 242, 242);
  border-radius: 20px 20px;
}
.card-title {
  font-size: 1.5rem;
  font-weight: bold;
}
.field-division {
  margin-top: 7px;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  /* height: 3rem; */
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  position: relative;
  bottom: -80%;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}
.footer-edit {
  width: 100%;
}
.field-label {
  font-size: 1.2rem;
  font-weight: bold;
}

.catbutton {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
}
.up-btn {
  width: 30%;
  font-size: 1.1rem;
  border-radius: 10px 10px;
  padding: 5px;
  color: #00377b;
  border: 1px solid #00377b;
  background-color: white;
}

.up-btn:hover {
  color: white;
  background-color: #00377b;
}

.active {
  color: white;
  background-color: #00377b;
}
.inactive {
  color: #00377b;
  background-color: white;
}

.metric-item-wrapper {
  margin-top: 10px;
  margin-bottom: 5px;
}

.metric-item-header {
  font-size: 1.5rem;
  font-weight: bolder;
}
.metric-item-text {
  font-size: 1.25rem;
  margin-top: 10px;
}

@media (max-width: 999px) {
  .v-button {
    width: inherit;
    /* height: 2.5rem; */
    font-size: 0.8rem;
  }
  .s-header {
    font-size: 16px;
  }

  .up-btn {
    width: 45%;
    font-size: 0.6rem;
  }
  .metric-item-header {
    font-size: 1rem;
  }
  .metric-item-text {
    font-size: 0.85rem;
    margin-top: 10px;
  }
}
</style>
